<template>
  <div class="reset-page">
    <h3 class="login_title" v-if="step !== 2">重置密码</h3>
    <el-steps :active="step" align-center class="reset-step" v-if="step !== 2">
      <el-step title="验证手机号码"></el-step>
      <el-step title="设置新密码"></el-step>
      <el-step title="密码重置成功"></el-step>
    </el-steps>

    <!-- 验证手机号码 -->
    <div class="step-item" v-if="step === 0">
      <el-form class="widget-form" :rules="validRule" ref="validForm" :model="validForm" size="medium">
        <el-form-item prop="phone">
          <el-input prefix-icon="el-icon-mobile" type="text" maxlength="11" show-word-limit :clearable="true" v-model="validForm.phone"
                    placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input prefix-icon="el-icon-message" type="text" v-model="validForm.code" placeholder="请输入短信验证码" :clearable="true">
            <el-button slot="append" @click="fetchCaptcha" :disabled="disabled">{{ text }}</el-button>
          </el-input>
        </el-form-item>
        <div class="margin-tb-10">
          <el-button type="primary" @click="doVerify" style="width: 100%">下一步</el-button>
        </div>
        <div class="text-align-center">
          <el-link type="primary" @click="toBack">返回账号登录</el-link>
        </div>
      </el-form>
    </div>

    <!-- 设置新密码 -->
    <div class="step-item" v-if="step === 1">
      <el-form class="widget-form" :rules="passwordRule" ref="newPwdForm" :model="newPwdForm" size="medium">
        <el-form-item prop="password">
          <el-input prefix-icon="el-icon-key" type="password" v-model="newPwdForm.password" placeholder="请设置6-20位登录密码" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item prop="rePassword">
          <el-input prefix-icon="el-icon-key" type="password" v-model="newPwdForm.rePassword" placeholder="请再次输入新的登录密码" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doConfirm" style="width: 100%">确定</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 密码重置成功 -->
    <div class="step-item" v-if="step === 2">
      <div class="success-icon"><i class="el-icon-circle-check"></i></div>
      <div class="success-title">密码重置成功</div>
      <el-button type="primary" @click="toBack" style="width: 100%">去登陆</el-button>
    </div>


  </div>
</template>

<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {fetchVerify, resetPwd, validCode} from "@api/system/user";

export default {
  mixins: [sendVerifyCode],
  data() {
    return {
      newPwdForm: {},
      validForm: {
        phone:null,
        code:null
      },
      step: 0,
      passwordRule: {
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
        rePassword: [
          {required: true, message: '请再次输入密码', trigger: 'blur'},
        ]
      },
      validRule: {
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {required: true, message: '请输入正确的电话号码', trigger: 'blur', pattern: /^1(3|4|5|7|8|9|6)\d{9}$/},
        ],
        code: [
          {required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    async fetchCaptcha() {
      let that = this
      this.$refs["validForm"].validateField("phone", flag => {
        if (!flag) {
          fetchVerify(this.validForm.phone, 'chgpwd').then(resp => {
            this.validForm.code = ''
            that.sendCode();
          })
        }
      })
    },
    doVerify() {
      this.$refs['validForm'].validate(valid => {
        if (valid) {
          const {phone, code} = this.validForm
          validCode(phone, code, 'chgpwd').then(resp => {
            if (resp.data.result) {
              this.step = 1
            } else {
              this.$message.error('对不起，您的验证码不正确！')
            }
          })
        }
      })
    },
    doConfirm() {
      this.$refs['newPwdForm'].validate(valid => {
        if (valid) {
          const {password, rePassword} = this.newPwdForm
          if(password === rePassword){
            resetPwd(this.validForm.phone,password).then(resp => {
              if(resp.data.code === 200){
                this.step = 2
              }else{
                this.$message.error('修改密码失败！')
              }
            })
          }else{
            this.$message.error('对不起，您两次输入的密码不一样！')
          }
        }
      })
    },
    toBack() {
      this.$emit('done')
    }

  }
}
</script>

<style lang="scss" scoped>
.reset-step{
  margin-bottom: 40px;
  .el-step {
    ::v-deep .el-step__head{
      &.is-finish{
        .el-step__icon{
          border-color: #1890ff;
        }
        .el-step__line{
          background-color: #1890ff;
        }
      }
      &.is-process{
        .el-step__icon{
          background-color: #1890ff;
          border-color: #1890ff;
        }
      }

      .el-step__line{
        top:8px;
      }
      .el-step__icon{
        width: 10px;
        height: 10px;
        .el-step__icon-inner{
          display: none;
        }
      }
    }
    ::v-deep .el-step__title {
      font-size: 12px;
      color: #ccc;
      font-weight: 400;

      &.is-finish,&.is-process {
        color: #666;
      }
    }
  }
}
.reset-page {
  .success-icon {
    margin: 110px auto 10px;
    text-align: center;

    i {
      color: #19BE6B;
      font-size: 72px;
    }
  }

  .success-title {
    font-size: 18px;
    font-weight: 700;
    font-family: 'Microsoft Yahei Regular', sans-serif;
    text-align: center;
    color: #666;
    margin: 5px auto 55px;
  }
}
</style>
